import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ListHorizontal } from 'ui/components';

import { ShipmentCustomer } from 'services/action';
import { ContactInformation } from './information.contact';
import { UpdateItems } from './items';

const initialState = {
  items: null,
};

export const FormReceive = ({ onSubmit, data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const [{ items }, setState] = React.useState(initialState);

  const $handleSubmit = async (e) => {
    const payload = {
      items
    };
    const req = await Dispatch(ShipmentCustomer.$receive(data?.id, payload));

    if (req?.message === 'success') {
      onSubmit();
    }
  };

  return (
    <>
      <div className="row mb-1">
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Shipment
        </div>
        <div className="col-6">
          <ListHorizontal
            title="Shipment"
            content={data?.code}
          />
          <ListHorizontal
            title="Kode Ref"
            content={data?.ref_code}
          />
          <ListHorizontal
            title="Customer"
            content={data?.customer?.name}
          />
        </div>
        <div className="col-6">
          <ListHorizontal
            title="Total Berat (Kg)"
            content={data?.total_weight}
          />
          <ListHorizontal
            title="Total Koli"
            content={data?.total_quantity}
          />
          <ListHorizontal
            title="COD Value"
            content={data?.cod_value}
          />
        </div>
        <div className="col-6">
          <ContactInformation
            data={data?.pickup_address}
            title="Origin"
            id="origin"
          />
        </div>
        <div className="col-6">
          <ContactInformation
            data={data?.recipient}
            title="Destinasi"
            id="recipient"
          />
        </div>
        <div className='col-12'>
          <UpdateItems
            data={data}
            errors={StateForm?.errors?.items}
            onUpdate={(e) => {
              setState((prevState) => ({
                ...prevState,
                items: e,
              }));
            }}
          />
        </div>
      </div>
      <button
        className={
          StateForm?.loading
            ? 'btn-loading btn btn-primary px-3 w-100'
            : 'btn btn-primary px-3 w-100'
        }
        onClick={$handleSubmit}
        type="button"
        disabled={StateForm?.loading}
      >
        Simpan
      </button>
    </>
  );
};
